import { render, staticRenderFns } from "./SpecialInitiatives.vue?vue&type=template&id=3a92036d&"
import script from "./SpecialInitiatives.vue?vue&type=script&lang=ts&"
export * from "./SpecialInitiatives.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports